/**
 * Shared color utility functions for state/attribute visualization.
 * Used across runners, sidebar, contacts, dashboard, etc.
 */

/** Heat color: green < 40, amber 40-60, red > 60 */
export function heatColor(v: number): string {
  return v > 60 ? 'var(--red)' : v > 40 ? 'var(--amber)' : 'var(--green)';
}

/** Loyalty color: red < 40, amber 40-60, green > 60 */
export function loyColor(v: number): string {
  return v < 40 ? 'var(--red)' : v < 60 ? 'var(--amber)' : 'var(--green)';
}

/** HP color: red < 30, amber 30-60, green > 60 */
export function hpColor(v: number): string {
  return v < 30 ? 'var(--red)' : v < 60 ? 'var(--amber)' : 'var(--green)';
}

/** Attribute color: amber < 40, green 40-70, cyan >= 70 */
export function attrColor(v: number): string {
  return v >= 70 ? 'var(--cyan)' : v >= 40 ? 'var(--green)' : 'var(--amber)';
}

/** Action result color */
export function resultColor(result: string): string {
  if (result === 'SUCCESS') return 'var(--green)';
  if (result === 'FAIL') return 'var(--red)';
  if (result === 'CRIT') return 'var(--amber)';
  return 'var(--text-lo)';
}
